import ReactComponent from 'lib/modulor/react_component'

import LoadableColumnModuleWidthInput from './loadable_column_module_width_input'
import LoadablePreview from './loadable_preview'

ReactComponent.register(LoadableColumnModuleWidthInput, 'ColumnModuleWidthInput')
ReactComponent.register(LoadablePreview, 'ColumnModuleWidthInput__Preview')
